export default __webpack_public_path__ + "static/bulabulacv-8d6f3b587546e66ba6546baa8f0bcc27.pdf";